import { render, staticRenderFns } from "./SmsTableModal.vue?vue&type=template&id=1c46bc84&scoped=true"
import script from "./SmsTableModal.vue?vue&type=script&lang=js"
export * from "./SmsTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46bc84",
  null
  
)

export default component.exports